module.exports = __webpack_public_path__ + "img/icon-bank.38337a89.svg";